import React from 'react'
import { IconProps } from '../../layout/Sidebar/types'

export const Visa: React.FC<IconProps> = ({ width, height, primaryColor }) => {
  return (
    <svg
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 71 23"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill={primaryColor}
        d="M30.797 22.13h-5.71L28.654.88h5.713l-3.57 21.25zM20.281.88l-5.446 14.615-.644-3.148-1.921-9.554a2.427 2.427 0 00-.977-1.496A2.411 2.411 0 009.56.88H.557l-.105.357c2.1.51 4.114 1.329 5.974 2.432l4.964 18.463h5.953L26.428.88H20.28zm44.926 21.247h5.245L65.88.88h-4.595a2.609 2.609 0 00-2.632 1.585l-8.52 19.668h5.955l1.191-3.156h7.261l.67 3.156-.002-.006zm-6.285-7.513l3.001-7.952 1.687 7.952h-4.688zM50.58 5.99l.816-4.564A16.948 16.948 0 0046.256.5c-2.834 0-9.565 1.2-9.565 7.035 0 5.49 7.9 5.559 7.9 8.442 0 2.884-7.085 2.367-9.424.55l-.85 4.77a16.44 16.44 0 006.447 1.2c3.899 0 9.779-1.955 9.779-7.275 0-5.527-7.972-6.04-7.972-8.442 0-2.403 5.563-2.094 8.007-.79h.001z"
      />
    </svg>
  )
}
